module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_7005.e349b521.png";